// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Pervasives = require("rescript/lib/js/pervasives.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var ListUtils$SmartcutsMacros = require("../../../bs-utils/src/ListUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../../bs-utils/src/StringUtils.bs.js");

function getQuerySelectorForCheckboxIdAndNameAndValue(id, name, value) {
  if (id !== undefined) {
    return "#" + id;
  } else if (name !== undefined) {
    if (value === "on") {
      return "input[type=checkbox][name='" + (name + "']");
    } else {
      return "input[type=checkbox][name='" + (name + ("'][value='" + (value + "']")));
    }
  } else if (value === "on") {
    return "input[type=checkbox]";
  } else {
    return "input[type=checkbox][value='" + (value + "']");
  }
}

function t_encode(v) {
  if (v) {
    return ["Uncheck"];
  } else {
    return ["Check"];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Check" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Check */0
                  };
          }
      case "Uncheck" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Uncheck */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify(action) {
  if (action) {
    return "Uncheck";
  } else {
    return "Check";
  }
}

function upsertOrRemoveValueInCheckedValues(action, value, checkedValues) {
  if (action) {
    return ListUtils$SmartcutsMacros.remove(value, checkedValues);
  } else {
    return ListUtils$SmartcutsMacros.upsert(value, checkedValues);
  }
}

var CheckboxAction = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify,
  upsertOrRemoveValueInCheckedValues: upsertOrRemoveValueInCheckedValues
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.optionToJson(Decco.stringToJson, v.id)
              ],
              [
                "label",
                Decco.optionToJson(Decco.stringToJson, v.label)
              ],
              [
                "value",
                Decco.stringToJson(v.value)
              ],
              [
                "checkedDefault",
                Decco.boolToJson(v.checkedDefault)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var label = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */0) {
      var value = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
      if (value.TAG === /* Ok */0) {
        var checkedDefault = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "checkedDefault"), null));
        if (checkedDefault.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    id: id._0,
                    label: label._0,
                    value: value._0,
                    checkedDefault: checkedDefault._0
                  }
                };
        }
        var e = checkedDefault._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".checkedDefault" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = value._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".value" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = label._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".label" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function stringify$1(param) {
  return "{label=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.label) + (", value=" + (param.value + ((
                  param.checkedDefault ? ", checked" : ""
                ) + (", id=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.id) + "}"))))));
}

var CheckboxOption = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "action",
                t_encode(v.action)
              ],
              [
                "id",
                Decco.optionToJson(Decco.stringToJson, v.id)
              ],
              [
                "value",
                Decco.stringToJson(v.value)
              ],
              [
                "name",
                Decco.optionToJson(Decco.stringToJson, v.name)
              ],
              [
                "label",
                Decco.optionToJson(Decco.stringToJson, v.label)
              ],
              [
                "options",
                Decco.listToJson(t_encode$1, v.options)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var action = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "action"), null));
  if (action.TAG === /* Ok */0) {
    var id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */0) {
      var value = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
      if (value.TAG === /* Ok */0) {
        var name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
        if (name.TAG === /* Ok */0) {
          var label = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
          if (label.TAG === /* Ok */0) {
            var options = Decco.listFromJson(t_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "options"), null));
            if (options.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        action: action._0,
                        id: id._0,
                        value: value._0,
                        name: name._0,
                        label: label._0,
                        options: options._0
                      }
                    };
            }
            var e = options._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".options" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = label._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".label" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = name._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".name" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = value._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".value" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".id" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = action._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".action" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function didInteractWithCheckboxOption(checkboxOption, interaction) {
  if (!Caml_obj.caml_equal(checkboxOption.id, interaction.id)) {
    return false;
  }
  if (!Caml_obj.caml_equal(checkboxOption.label, interaction.label)) {
    return false;
  }
  var match = interaction.value;
  var match$1 = checkboxOption.value;
  if (match === "on" && match$1 === "") {
    return true;
  } else {
    return interaction.value === checkboxOption.value;
  }
}

function stringify$2(param) {
  return "{action=" + ((
            param.action ? "Uncheck" : "Check"
          ) + (", value=" + (StringUtils$SmartcutsMacros.quote(param.value) + (", name=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.name) + (", label=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.label) + (", id=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.id) + (", options=" + (StringUtils$SmartcutsMacros.join(", ", List.map(stringify$1, param.options)) + "}")))))))))));
}

var SingleCheckboxInteraction = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  didInteractWithCheckboxOption: didInteractWithCheckboxOption,
  stringify: stringify$2
};

function t_encode$3(v) {
  return Js_dict.fromArray([
              [
                "label",
                Decco.optionToJson(Decco.stringToJson, v.label)
              ],
              [
                "interaction",
                t_encode$2(v.interaction)
              ]
            ]);
}

function t_decode$3(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var label = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
  if (label.TAG === /* Ok */0) {
    var interaction = t_decode$2(Belt_Option.getWithDefault(Js_dict.get(dict$1, "interaction"), null));
    if (interaction.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                label: label._0,
                interaction: interaction._0
              }
            };
    }
    var e = interaction._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".interaction" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = label._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".label" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$3(param) {
  return "{label=" + (OptionUtils$SmartcutsMacros.withDefault("undefined", param.label) + (", interaction=" + (stringify$2(param.interaction) + "}")));
}

var LabeledSingleCheckboxInteraction = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  stringify: stringify$3
};

function t_encode$4(v) {
  return Js_dict.fromArray([
              [
                "name",
                Decco.stringToJson(v.name)
              ],
              [
                "checkedValues",
                Decco.listToJson(Decco.stringToJson, v.checkedValues)
              ],
              [
                "options",
                Decco.listToJson(t_encode$1, v.options)
              ]
            ]);
}

function t_decode$4(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var checkedValues = Decco.listFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "checkedValues"), null));
    if (checkedValues.TAG === /* Ok */0) {
      var options = Decco.listFromJson(t_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict$1, "options"), null));
      if (options.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  name: name._0,
                  checkedValues: checkedValues._0,
                  options: options._0
                }
              };
      }
      var e = options._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".options" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = checkedValues._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".checkedValues" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringify$4(param) {
  return "{name=" + (param.name + (", checkedValues=" + (StringUtils$SmartcutsMacros.join(", ", param.checkedValues) + (", options=" + (StringUtils$SmartcutsMacros.join(", ", List.map(stringify$1, param.options)) + "}")))));
}

var CheckboxGroupWithChosenValues = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  stringify: stringify$4
};

function t_encode$5(v) {
  if (v.TAG === /* SingleCheckbox */0) {
    return [
            "SingleCheckbox",
            t_encode$1(v._0),
            Decco.boolToJson(v._1)
          ];
  } else {
    return [
            "CheckboxGroup",
            t_encode$4(v._0)
          ];
  }
}

function t_decode$5(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CheckboxGroup" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$4(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CheckboxGroup */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "SingleCheckbox" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = t_decode$1(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.boolFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* SingleCheckbox */0,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$5(choice) {
  if (choice.TAG === /* SingleCheckbox */0) {
    return "SingleCheckbox(checkboxOption" + (stringify$1(choice._0) + (", checked=" + (Pervasives.string_of_bool(choice._1) + ")")));
  } else {
    return "CheckboxGroup(" + (stringify$4(choice._0) + ")");
  }
}

var CheckboxChoice = {
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  stringify: stringify$5
};

function t_encode$6(v) {
  if (v.TAG === /* IndividualCheckOrUncheck */0) {
    return [
            "IndividualCheckOrUncheck",
            t_encode$3(v._0)
          ];
  } else {
    return [
            "MultipleChecksOrUnchecks",
            t_encode$4(v._0)
          ];
  }
}

function t_decode$6(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "IndividualCheckOrUncheck" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$3(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* IndividualCheckOrUncheck */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "MultipleChecksOrUnchecks" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = t_decode$4(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* MultipleChecksOrUnchecks */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$6(value) {
  if (value.TAG === /* IndividualCheckOrUncheck */0) {
    return "IndividualCheckOrUncheck(" + (stringify$3(value._0) + ")");
  } else {
    return "MultipleChecksOrUnchecks(" + (stringify$4(value._0) + ")");
  }
}

function selectorGet(param) {
  return [];
}

var CheckboxPlaybackCommandValue = {
  t_encode: t_encode$6,
  t_decode: t_decode$6,
  stringify: stringify$6,
  selectorGet: selectorGet
};

var t_encode$7 = t_encode$3;

var t_decode$7 = t_decode$3;

var Recording = {
  t_encode: t_encode$7,
  t_decode: t_decode$7,
  stringify: stringify$3
};

var t_encode$8 = t_encode$6;

var t_decode$8 = t_decode$6;

var Authoring = {
  t_encode: t_encode$8,
  t_decode: t_decode$8,
  stringify: stringify$6
};

var t_encode$9 = t_encode$6;

var t_decode$9 = t_decode$6;

var Playback = {
  t_encode: t_encode$9,
  t_decode: t_decode$9,
  stringify: stringify$6
};

var CommandValue = {
  CheckboxOption: CheckboxOption,
  SingleCheckboxInteraction: SingleCheckboxInteraction,
  LabeledSingleCheckboxInteraction: LabeledSingleCheckboxInteraction,
  CheckboxGroupWithChosenValues: CheckboxGroupWithChosenValues,
  CheckboxChoice: CheckboxChoice,
  CheckboxPlaybackCommandValue: CheckboxPlaybackCommandValue,
  Recording: Recording,
  Authoring: Authoring,
  Playback: Playback
};

function t_encode$10(v) {
  return Js_dict.fromArray([
              [
                "checkboxChoice",
                t_encode$5(v.checkboxChoice)
              ],
              [
                "playbackFormLabel",
                Decco.stringToJson(v.playbackFormLabel)
              ],
              [
                "dynamic",
                Decco.boolToJson(v.dynamic)
              ]
            ]);
}

function t_decode$10(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var checkboxChoice = t_decode$5(Belt_Option.getWithDefault(Js_dict.get(dict$1, "checkboxChoice"), null));
  if (checkboxChoice.TAG === /* Ok */0) {
    var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
    if (playbackFormLabel.TAG === /* Ok */0) {
      var dynamic = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dynamic"), null));
      if (dynamic.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  checkboxChoice: checkboxChoice._0,
                  playbackFormLabel: playbackFormLabel._0,
                  dynamic: dynamic._0
                }
              };
      }
      var e = dynamic._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".dynamic" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = playbackFormLabel._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".playbackFormLabel" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = checkboxChoice._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".checkboxChoice" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function isDynamic(param) {
  return param.dynamic;
}

function fromAuthoringCommandValue(cmdVal) {
  if (cmdVal.TAG === /* IndividualCheckOrUncheck */0) {
    var match = cmdVal._0;
    var match$1 = match.interaction;
    var options = match$1.options;
    var maybeName = match$1.name;
    var action = match$1.action;
    var checkboxChoice = options ? (
        maybeName !== undefined ? (
            options.tl ? ({
                  TAG: /* CheckboxGroup */1,
                  _0: {
                    name: maybeName,
                    checkedValues: upsertOrRemoveValueInCheckedValues(action, match$1.value, List.map((function (param) {
                                return param.value;
                              }), List.filter(function (param) {
                                    return param.checkedDefault;
                                  })(options))),
                    options: options
                  }
                }) : ({
                  TAG: /* SingleCheckbox */0,
                  _0: options.hd,
                  _1: action === /* Check */0
                })
          ) : (
            options.tl ? Util$SmartcutsMacros.logAndRaiseJsError("A checkbox group must be unified by name") : ({
                  TAG: /* SingleCheckbox */0,
                  _0: options.hd,
                  _1: action === /* Check */0
                })
          )
      ) : Util$SmartcutsMacros.logAndRaiseJsError("Expects at least one option");
    return {
            checkboxChoice: checkboxChoice,
            playbackFormLabel: OptionUtils$SmartcutsMacros.withDefault("[Add a label]", match.label),
            dynamic: false
          };
  }
  var checkboxGroupWithChosenValues = cmdVal._0;
  return {
          checkboxChoice: {
            TAG: /* CheckboxGroup */1,
            _0: checkboxGroupWithChosenValues
          },
          playbackFormLabel: checkboxGroupWithChosenValues.name,
          dynamic: false
        };
}

function updateConfigWithAuthoringCommandValue(commandValue, config) {
  var checkboxGroupWithChosenValues = config.checkboxChoice;
  if (checkboxGroupWithChosenValues.TAG === /* SingleCheckbox */0) {
    var checkboxOption = checkboxGroupWithChosenValues._0;
    if (commandValue.TAG !== /* IndividualCheckOrUncheck */0) {
      return Util$SmartcutsMacros.logAndRaiseJsError("Single checkbox config cannot be merged with multiple checkbox command");
    }
    var checkboxInteraction = commandValue._0.interaction;
    if (didInteractWithCheckboxOption(checkboxOption, checkboxInteraction)) {
      return {
              checkboxChoice: {
                TAG: /* SingleCheckbox */0,
                _0: checkboxOption,
                _1: checkboxInteraction.action === /* Check */0
              },
              playbackFormLabel: config.playbackFormLabel,
              dynamic: config.dynamic
            };
    } else {
      return Util$SmartcutsMacros.logAndRaiseJsError("Expected checkbox interaction to interact with the checkbox option from checkbox config");
    }
  }
  var checkboxGroupWithChosenValues$1 = checkboxGroupWithChosenValues._0;
  if (commandValue.TAG === /* IndividualCheckOrUncheck */0) {
    var checkboxInteraction$1 = commandValue._0.interaction;
    var isMatch = List.exists((function (checkboxOption) {
            return didInteractWithCheckboxOption(checkboxOption, checkboxInteraction$1);
          }), checkboxGroupWithChosenValues$1.options);
    if (isMatch) {
      return {
              checkboxChoice: {
                TAG: /* CheckboxGroup */1,
                _0: {
                  name: checkboxGroupWithChosenValues$1.name,
                  checkedValues: upsertOrRemoveValueInCheckedValues(checkboxInteraction$1.action, checkboxInteraction$1.value, checkboxGroupWithChosenValues$1.checkedValues),
                  options: checkboxGroupWithChosenValues$1.options
                }
              },
              playbackFormLabel: config.playbackFormLabel,
              dynamic: config.dynamic
            };
    } else {
      return Util$SmartcutsMacros.logAndRaiseJsError("Expected checkbox interaction to interact with one of the checkbox options from checkbox config");
    }
  }
  var match = commandValue._0;
  if (checkboxGroupWithChosenValues$1.name === match.name) {
    return {
            checkboxChoice: {
              TAG: /* CheckboxGroup */1,
              _0: {
                name: checkboxGroupWithChosenValues$1.name,
                checkedValues: match.checkedValues,
                options: checkboxGroupWithChosenValues$1.options
              }
            },
            playbackFormLabel: config.playbackFormLabel,
            dynamic: config.dynamic
          };
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Expected checkbox interaction to interact with one of the checkbox options from checkbox config");
  }
}

var AuthoringConfig = {
  t_encode: t_encode$10,
  t_decode: t_decode$10,
  isDynamic: isDynamic,
  fromAuthoringCommandValue: fromAuthoringCommandValue,
  updateConfigWithAuthoringCommandValue: updateConfigWithAuthoringCommandValue
};

function t_encode$11(v) {
  return Js_dict.fromArray([
              [
                "originalCheckboxChoice",
                t_encode$5(v.originalCheckboxChoice)
              ],
              [
                "playbackFormLabel",
                Decco.stringToJson(v.playbackFormLabel)
              ]
            ]);
}

function t_decode$11(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var originalCheckboxChoice = t_decode$5(Belt_Option.getWithDefault(Js_dict.get(dict$1, "originalCheckboxChoice"), null));
  if (originalCheckboxChoice.TAG === /* Ok */0) {
    var playbackFormLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackFormLabel"), null));
    if (playbackFormLabel.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                originalCheckboxChoice: originalCheckboxChoice._0,
                playbackFormLabel: playbackFormLabel._0
              }
            };
    }
    var e = playbackFormLabel._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".playbackFormLabel" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = originalCheckboxChoice._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".originalCheckboxChoice" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function fromAuthoringConfig(param) {
  return {
          originalCheckboxChoice: param.checkboxChoice,
          playbackFormLabel: param.playbackFormLabel
        };
}

var ParamDescriptor = {
  t_encode: t_encode$11,
  t_decode: t_decode$11,
  fromAuthoringConfig: fromAuthoringConfig
};

var t_encode$12 = t_encode$5;

var t_decode$12 = t_decode$5;

function fromParamDescriptor(param) {
  return param.originalCheckboxChoice;
}

function toCommandValueForPlayback(paramValue) {
  if (paramValue.TAG !== /* SingleCheckbox */0) {
    return {
            TAG: /* MultipleChecksOrUnchecks */1,
            _0: paramValue._0
          };
  }
  var checkboxOption = paramValue._0;
  var label = checkboxOption.label;
  return {
          TAG: /* IndividualCheckOrUncheck */0,
          _0: {
            label: label,
            interaction: {
              action: paramValue._1 ? /* Check */0 : /* Uncheck */1,
              id: checkboxOption.id,
              value: checkboxOption.value,
              name: undefined,
              label: label,
              options: {
                hd: checkboxOption,
                tl: /* [] */0
              }
            }
          }
        };
}

var PlaybackParamValue = {
  t_encode: t_encode$12,
  t_decode: t_decode$12,
  stringify: stringify$5,
  fromParamDescriptor: fromParamDescriptor,
  toCommandValueForPlayback: toCommandValueForPlayback
};

exports.getQuerySelectorForCheckboxIdAndNameAndValue = getQuerySelectorForCheckboxIdAndNameAndValue;
exports.CheckboxAction = CheckboxAction;
exports.CommandValue = CommandValue;
exports.AuthoringConfig = AuthoringConfig;
exports.ParamDescriptor = ParamDescriptor;
exports.PlaybackParamValue = PlaybackParamValue;
/* Util-SmartcutsMacros Not a pure module */
